import Vue from 'vue'
import Router from 'vue-router'
import HomeIndex from '@/pages/HomeIndex'
import mine from '@/pages/mine/mine'
import account from '@/pages/account/account'
import tixian from '@/pages/account/tixian'
import oilCard from '@/pages/oilcard/oilCard'
import phone from '@/pages/phone/phone'
import videoList from '@/pages/video/videoList'
import videoDetail from '@/pages/video/videoDetail'
import tengxunList from '@/pages/tengxun/tengxunList'
import tengxunDetail from '@/pages/tengxun/tengxunDetail'
import shoppingList from '@/pages/shop/shoppingList'
import shoppingDetail from '@/pages/shop/shoppingDetail'
import APPshoppingList from '@/pages/shop/APPshoppingList'
import APPshoppingDetail from '@/pages/shop/AppshoppingDetail'
import foodList from '@/pages/food/foodList'
import foodDetail from '@/pages/food/foodDetail'
import chuxingList from '@/pages/chuxing/chuxingList'
import chuxingDetail from '@/pages/chuxing/chuxingDetail'
import gamesList from '@/pages/games/gamesList'
import gamesDetail from '@/pages/games/gamesDetail'
import lifeList from '@/pages/life/lifeList'
import lifeDetail from '@/pages/life/lifeDetail'
import orderList from '@/pages/order/orderList'
import orderListDetail from '@/pages/order/orderListDetail'
import jifenmingxi from '@/pages/jifenList/jifenmingxi'
import login from '@/pages/login/login'
import zhanghuAdd from '@/pages/account/zhanghuAdd'
import changePhoneNum from '@/pages/login/changePhoneNum'
import withdrawList from '@/pages/account/withdrawList'
import withdrawDetail from '@/pages/account/withdrawDetail'
import serviceList from '@/pages/xianxia/serviceList'
import serviceDesc from '@/pages/xianxia/serviceDesc'
import offlineserverList from '@/pages/offline/serverList'
import offlineserverDetail from '@/pages/offline/serverDetail'
import packageDesc from '@/pages/xianxia/packageDesc'
import reserveDesc from '@/pages/xianxia/reserveDesc'
import buy from '@/pages/xianxia/buy'
import liceseList from '@/pages/xianxia/liceseList'
import licenseEdit from '@/pages/xianxia/licenseEdit'
import couponsList from '@/pages/kaquan/couponsList'
import couponsDesc from '@/pages/kaquan/couponsDesc'
import couponDetailPro from '@/pages/kaquan/couponDetailPro'
import detailBook from '@/pages/xianxia/detailBook'
import yuyuetip from '@/pages/xianxia/yuyuetip'
import oilCardList from '@/pages/oilcard/oilCardList'
import oilCardAdd from '@/pages/oilcard/oilCardAdd'
import moveCar from '@/pages/xianxia/moveCar'
import roadRescue from '@/pages/xianxia/roadRescue'
import supplementary from '@/pages/supplementary/supplementary'
import productList from '@/pages/project/productList'
import projectDetail from '@/pages/project/projectDetail'
import projectBuy from '@/pages/project/projectBuy'
import projectAddressList from '@/pages/project/projectAddressList'
import projectAddAddress from '@/pages/project/projectAddAddress'
import yearlyInspection from '@/pages/xianxia/yearlyInspection'
import cardList from '@/pages/account/cardList'
import cardWithdraw from '@/pages/account/cardWithdraw'
import cardWithdrawAdd from '@/pages/account/cardWithdrawAdd'
import AppShop from '@/pages/AppShop/AppShop'
import CarLicenseList from '@/pages/xianxia/CarLicenseList'
import CarLicenseAdd from '@/pages/xianxia/CarLicenseAdd'
import yearlyconfirm from '@/pages/xianxia/yearlyconfirm'
import chooseLocation from '@/pages/xianxia/chooseLocation'
import orderGrabbing from '@/pages/orderGrabbing/orderGrabbing'
import orderStatus from '@/pages/orderGrabbing/orderStatus'
import grabbingLogin from '@/pages/orderGrabbing/grabbingLogin'
import yearInspectionType from '@/pages/xianxia/yearInspectionType'
import appointmentYearInsp from '@/pages/xianxia/appointmentYearInsp'
import SecondPayment from '@/pages/SecondPayment/SecondPayment'
import annualReviewList from '@/pages/xianxia/annualReviewList'
import annualReviewDetail from '@/pages/xianxia/annualReviewDetail'
import IntegralRecharge from '@/pages/account/IntegralRecharge'
import LuckyWheel from '@/pages/luckDraw/luckywheel'
import getPrize from '@/pages/getPrize/getPrize'
import receiveSuccess from '@/pages/getPrize/receiveSuccess'
import processPrize from '@/pages/getPrize/processPrize'
import logistics from '@/pages/project/logistics'
import sellingCards from '@/pages/account/sellingCards'
import rule from '@/pages/account/rule'
import storeService from '@/pages/storeService/storeService'
import jingdongRecharge from '@/pages/jingdong/jingdongRecharge'
import rechargeJD from '@/pages/jingdong/rechargeJD'
import jiayou from '@/pages/jiayou/jiayou'
import jiayouDetail from '@/pages/jiayou/jiayouDetail'
import banklist from '@/pages/mine/banklist'
import addbank from '@/pages/mine/addbank'
import charge from '@/pages/telaidian/charge'
import carddetail from '@/pages/service/carddetail'
import storedetail from '@/pages/service/storedetail'
import storelist from '@/pages/service/storelist'
import editinfo from '@/pages/login/editinfo'
import alipay from '@/pages/alipaypage/alipay'
import paymentpage from '@/pages/payment/paymentpage'
import paysuccess from '@/pages/payment/paysuccess'
import alipayorder from '@/pages/alipaypage/alipayorder'
import alipayorderDetail from '@/pages/alipaypage/alipayorderDetail'
import youlegou from '@/pages/youlegou/youlegou'
import youlegouAddAddress from '@/pages/youlegou/youlegouAddAddress'
import youlegouAddressList from '@/pages/youlegou/youlegouAddressList'
import youlegouBuy from '@/pages/youlegou/youlegouBuy'
import youlegoudetail from '@/pages/youlegou/youlegoudetail'
import youlegoulogistics from '@/pages/youlegou/youlegoulogistics'
import usealipay from '@/pages/alipaypage/usealipay'
import table from '@/pages/table/table'
import paypage from '@/pages/xianxia/paypage'
import privacyAgreement from '@/pages/login/privacyAgreement'
import text from '@/pages/offline/text'
import evaluateList from '@/pages/offline/evaluateList'
import serveEvaluate from '@/pages/offline/serveEvaluate'
import vipcard from '@/pages/vipCard/vipCard'
import reservation from '@/pages/offline/reservation'
import orderConfirm from '@/pages/offline/orderConfirm'
import vipPricacy from '@/pages/vipCard/vipPricacy'
import withdrawal from '@/pages/account/withdrawal'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [{
      path: '/',
      name: 'HomeIndex',
      component: HomeIndex,
      meta: {
        //title:"首页"
      }
    },
    {
      path: '/mine',
      name: 'mine',
      component: mine,
      meta: {
        //title:"个人中心"
      }

    },
    {
      path: '/banklist',
      name: 'banklist',
      component: banklist,
      meta: {
        //title:"积分充值"
      }
    }, {
      path: '/addbank',
      name: 'addbank',
      component: addbank,
      meta: {
        //title:"积分充值"
      }
    },
    {
      path: '/account',
      name: 'account',
      component: account,
      meta: {
        //title:"积分充值"
      }
    },
    {
      path: '/tixian',
      name: 'tixian',
      component: tixian,
      meta: {
        //title:"余额转让"
      }
    },
    {
      path: '/oilCard',
      name: 'oilCard',
      component: oilCard,
      meta: {
        //title:"油卡充值"
      }
    },
    {
      path: '/phone',
      name: 'phone',
      component: phone,
      meta: {
        //title:"手机充值"
      }
    },
    {
      path: '/videoList',
      name: 'videoList',
      component: videoList,
      meta: {
        //title:"娱乐会员"
      }
    },
    {
      path: '/videoDetail',
      name: 'videoDetail',
      component: videoDetail,
      meta: {
        //title:"娱乐会员"
      }
    },
    {
      path: '/tengxunList',
      name: 'tengxunList',
      component: tengxunList
    },
    {
      path: '/tengxunDetail',
      name: 'tengxunDetail',
      component: tengxunDetail
    },
    {
      path: '/shoppingList',
      name: 'shoppingList',
      component: shoppingList
    },
    {
      path: '/AppShop',
      name: 'AppShop',
      component: AppShop,
      meta: {
        //title:"App购物卡"
      }
    },
    {
      path: '/shoppingDetail',
      name: 'shoppingDetail',
      component: shoppingDetail,
      meta: {
        //title:"券享生活"
      }
    },
    {
      path: '/APPshoppingList',
      name: 'APPshoppingList',
      component: APPshoppingList
    },
    {
      path: '/APPshoppingDetail',
      name: 'APPshoppingDetail',
      component: APPshoppingDetail,
      meta: {
        //title:"充值"
      }
    },
    {
      path: '/foodList',
      name: 'foodList',
      component: foodList
    },
    {
      path: '/foodDetail',
      name: 'foodDetail',
      component: foodDetail
    },
    {
      path: '/chuxingList',
      name: 'chuxingList',
      component: chuxingList
    },
    {
      path: '/chuxingDetail',
      name: 'chuxingDetail',
      component: chuxingDetail
    },
    {
      path: '/gamesList',
      name: 'gamesList',
      component: gamesList
    },
    {
      path: '/gamesDetail',
      name: 'gamesDetail',
      component: gamesDetail
    },
    {
      path: '/lifeList',
      name: 'lifeList',
      component: lifeList
    },
    {
      path: '/lifeDetail',
      name: 'lifeDetail',
      component: lifeDetail
    },
    {
      path: '/orderList',
      name: 'orderList',
      component: orderList,
      meta: {
        //title:"订单列表"
      }
    },
    {
      path: '/orderListDetail',
      name: 'orderListDetail',
      component: orderListDetail,
      meta: {
        //title:"订单详情"
      }
    },
    {
      path: '/jifenmingxi',
      name: 'jifenmingxi',
      component: jifenmingxi,
      meta: {
        //title:"积分明细"
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        //title:"登录"
      }
    },
    {
      path: '/zhanghuAdd',
      name: 'zhanghuAdd',
      component: zhanghuAdd,
      meta: {
        //title:"添加账户"
      }
    },
    {
      path: '/changePhoneNum',
      name: 'changePhoneNum',
      component: changePhoneNum,
      meta: {
        //title:"绑定手机"
      }
    },
    {
      path: '/withdrawList',
      name: 'withdrawList',
      component: withdrawList,
      meta: {
        //title:"提现列表"
      }
    },
    {
      path: '/withdrawDetail',
      name: 'withdrawDetail',
      component: withdrawDetail,
      meta: {
        //title:"提现详情"
      }
    },
    {
      path: '/serviceList',
      name: 'serviceList',
      component: serviceList,
      meta: {
        //title:"服务列表"
      }

    },
    {
      path: '/serviceDesc',
      name: 'serviceDesc',
      component: serviceDesc,
      meta: {
        //title:"服务详情"
      }
    },
    {
      path: '/packageDesc',
      name: 'packageDesc',
      component: packageDesc,
      meta: {
        //title:"购买详情"
      }
    },
    {
      path: '/reserveDesc',
      name: 'reserveDesc',
      component: reserveDesc,
      meta: {
        //title:"预约详情"
      }

    },
    {
      path: '/buy',
      name: 'buy',
      component: buy,
      meta: {
        //title:"购买"
      }
    },
    {
      path: '/liceseList',
      name: 'liceseList',
      component: liceseList,
      meta: {
        //title:"车牌列表"
      }
    },
    {
      path: '/licenseEdit',
      name: 'licenseEdit',
      component: licenseEdit,
      meta: {
        //title:"新增车牌"
      }
    },
    {
      path: '/couponsList',
      name: 'couponsList',
      component: couponsList,
      meta: {
        //title:"卡券列表"
      }
    },
    {
      path: '/couponsDesc',
      name: 'couponsDesc',
      component: couponsDesc,
      meta: {
        //title:"卡券详情"
      }
    },
    {
      path: '/couponDetailPro',
      name: 'couponDetailPro',
      component: couponDetailPro,
      meta: {
        //title:"卡券详情"
      }
    },
    {
      path: '/detailBook',
      name: 'detailBook',
      component: detailBook,
      meta: {
        //title:"预约详情"
      }
    },
    {
      path: '/yuyuetip',
      name: 'yuyuetip',
      component: yuyuetip,
      meta: {
        //title:"车辆送检"
      }
    },
    {
      path: '/oilCardList',
      name: 'oilCardList',
      component: oilCardList,
      meta: {
        //title:"油卡列表"
      }

    },
    {
      path: '/oilCardAdd',
      name: 'oilCardAdd',
      component: oilCardAdd,
      meta: {
        //title:"添加油卡"
      }
    },
    {
      path: '/moveCar',
      name: 'moveCar',
      component: moveCar,
      meta: {
        //title:"挪车服务"
      }
    },
    {
      path: '/roadRescue',
      name: 'roadRescue',
      component: roadRescue,
      meta: {
        //title: "道路救援"
      }
    },
    {
      path: '/supplementary',
      name: 'supplementary',
      component: supplementary
    },
    {
      path: '/projectDetail',
      name: 'projectDetail',
      component: projectDetail,
      meta: {
        //title: "商品详情"
      }
    },
    {
      path: '/projectBuy',
      name: 'projectBuy',
      component: projectBuy,
      meta: {
        //title: "商品购买"
      }
    },
    {
      path: '/projectAddressList',
      name: 'projectAddressList',
      component: projectAddressList,
      meta: {
        //title: "地址列表"
      }
    },
    {
      path: '/projectAddAddress',
      name: 'projectAddAddress',
      component: projectAddAddress,
      meta: {
        //title: "新增地址"
      }
    },
    {
      path: '/productList',
      name: 'productList',
      component: productList,
      meta: {
        //title: "商品列表"
      }
    },
    {
      path: '/yearlyInspection',
      name: 'yearlyInspection',
      component: yearlyInspection,
      meta: {
        //title: "车辆年审"
        keepAlive: true
      }

    },
    {
      path: '/cardList',
      name: 'cardList',
      component: cardList,
      meta: {
        //title: "积分领取"
      }
    },
    {
      path: '/cardWithdraw',
      name: 'cardWithdraw',
      component: cardWithdraw,
      meta: {
        //title: "卡券转让"
      }
    },
    {
      path: '/cardWithdrawAdd',
      name: 'cardWithdrawAdd',
      component: cardWithdrawAdd,
      meta: {
        //title: "新增账户"
      }
    },
    {
      path: '/CarLicenseList',
      name: 'CarLicenseList',
      component: CarLicenseList,
      meta: {
        //title: "车牌列表"
      }
    },
    {
      path: '/CarLicenseAdd',
      name: 'CarLicenseAdd',
      component: CarLicenseAdd,
      meta: {
        //title: "车牌列表"
      }
    },
    {
      path: '/yearlyconfirm',
      name: 'yearlyconfirm',
      component: yearlyconfirm,
      meta: {
        //title: "确认支付"
      }
    },
    {
      path: '/chooseLocation',
      name: 'chooseLocation',
      component: chooseLocation,
      meta: {
        //title: "选择地址"
      }
    },
    {
      path: '/orderGrabbing',
      name: 'orderGrabbing',
      component: orderGrabbing,
      meta: {
        //title: "抢单"
      }
    },
    {
      path: '/orderStatus',
      name: 'orderStatus',
      component: orderStatus,
      meta: {
        //title: "抢单状态"
      }
    },
    {
      path: '/grabbingLogin',
      name: 'grabbingLogin',
      component: grabbingLogin,
      meta: {
        //title: "登录"
      }
    },
    {
      path: '/yearInspectionType',
      name: 'yearInspectionType',
      component: yearInspectionType
    },
    {
      path: '/appointmentYearInsp',
      name: 'appointmentYearInsp',
      component: appointmentYearInsp
    },
    {
      path: '/SecondPayment',
      name: 'SecondPayment',
      component: SecondPayment
    },
    {
      path: '/annualReviewList',
      name: 'annualReviewList',
      component: annualReviewList
    },
    {
      path: '/annualReviewDetail',
      name: 'annualReviewDetail',
      component: annualReviewDetail
    },
    {
      path: '/IntegralRecharge',
      name: 'IntegralRecharge',
      component: IntegralRecharge
    },
    {
      path: '/LuckyWheel',
      name: 'LuckyWheel',
      component: LuckyWheel
    },
    {
      path: '/getPrize',
      name: 'getPrize',
      component: getPrize
    },
    {
      path: '/receiveSuccess',
      name: 'receiveSuccess',
      component: receiveSuccess
    },
    {
      path: '/processPrize',
      name: 'processPrize',
      component: processPrize
    },
    {
      path: '/logistics',
      name: 'logistics',
      component: logistics
    },
    {
      path: '/sellingCards',
      name: 'sellingCards',
      component: sellingCards
    },
    {
      path: '/rule',
      name: 'rule',
      component: rule
    },
    {
      path: '/storeService',
      name: 'storeService',
      component: storeService,
      meta: {
        title: "店铺修改"
      }
    },
    {
      path: '/jingdongRecharge',
      name: 'jingdongRecharge',
      component: jingdongRecharge
    },
    {
      path: '/rechargeJD',
      name: 'rechargeJD',
      component: rechargeJD
    },
    {
      path: '/jiayou',
      name: 'jiayou',
      component: jiayou
    },
    {
      path: '/jiayouDetail',
      name: 'jiayouDetail',
      component: jiayouDetail
    },
    {
      path: '/charge',
      name: 'charge',
      component: charge
    },
    {
      path: '/carddetail',
      name: 'carddetail',
      component: carddetail
    },
    {
      path: '/storedetail',
      name: 'storedetail',
      component: storedetail
    },
    {
      path: '/storelist',
      name: 'storelist',
      component: storelist
    }, {
      path: '/editinfo',
      name: 'editinfo',
      component: editinfo
    }, {
      path: '/alipay',
      name: 'alipay',
      component: alipay
    }, {
      path: '/paymentpage',
      name: 'paymentpage',
      component: paymentpage
    }, {
      path: '/paysuccess',
      name: 'paysuccess',
      component: paysuccess
    }, {
      path: '/alipayorder',
      name: 'alipayorder',
      component: alipayorder
    }, {
      path: '/alipayorderDetail',
      name: 'alipayorderDetail',
      component: alipayorderDetail
    }, {
      path: '/youlegou',
      name: 'youlegou',
      component: youlegou
    }, {
      path: '/usealipay',
      name: 'usealipay',
      component: usealipay
    }, {
      path: '/table',
      name: 'table',
      component: table
    }, {
      path: '/youlegouAddAddress',
      name: 'youlegouAddAddress',
      component: youlegouAddAddress
    }, {
      path: '/youlegouAddressList',
      name: 'youlegouAddressList',
      component: youlegouAddressList
    }, {
      path: '/youlegouBuy',
      name: 'youlegouBuy',
      component: youlegouBuy
    }, {
      path: '/youlegoudetail',
      name: 'youlegoudetail',
      component: youlegoudetail
    }, {
      path: '/youlegoulogistics',
      name: 'youlegoulogistics',
      component: youlegoulogistics
    }, {
      path: '/paypage',
      name: 'paypage',
      component: paypage
    }, {
      path: '/privacyAgreement',
      name: 'privacyAgreement',
      component: privacyAgreement
    },{
      path: '/offlineserverList',
      name: 'offlineserverList',
      component: offlineserverList
    },{
      path: '/offlineserverDetail',
      name: 'offlineserverDetail',
      component: offlineserverDetail
    },{
      path: '/text',
      name: 'text',
      component: text
    },{
      path: '/evaluateList',
      name: 'evaluateList',
      component: evaluateList
    },{
      path: '/serveEvaluate',
      name: 'serveEvaluate',
      component: serveEvaluate
    },{
      path: '/vipcard',
      name: 'vipcard',
      component: vipcard
    },{
      path: '/reservation',
      name: 'reservation',
      component: reservation
    },{
      path: '/orderConfirm',
      name: 'orderConfirm',
      component: orderConfirm
    },{
      path: '/vipPricacy',
      name: 'vipPricacy',
      component: vipPricacy
    },{
      path: '/withdrawal',
      name: 'withdrawal',
      component: withdrawal
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js